import type { Mission } from '../missions.ts'

export const usbr: Mission = {
  id: "usbr",
  name: "Bureau of Reclamation",
  short: "Reclamation",
  call: "Water",
  kind: "subagency",
  parent: "doi",
  url: "https://www.usbr.gov/",
  established: 1902,
  palette: {
    primary: "#213f8c",
    secondary: "#172958",
    accent: "#ca9117",
  },
  colorSource: {
    kind: "site",
    url: "https://www.usbr.gov/",
  },
  motif: "wave",
  mission: {
    text: "The mission of the Bureau of Reclamation is to manage, develop, and protect water and related resources in an environmentally and economically sound manner in the interest of the American public.",
    url: "https://www.usbr.gov/main/about/mission.html",
  },
  fact: {
    text: "Reclamation is the largest wholesaler of water in the country and the second largest producer of hydroelectric power in the United States.",
    url: "https://www.usbr.gov/main/about/mission.html",
  },
  seal: {
    file: "public/seals/usbr.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-DOI-BureauOfReclamation-Seal.svg",
  },
  identifier: {
    about: "https://www.usbr.gov/main/about/",
    accessibility: "https://www.usbr.gov/main/access.html",
    foia: "https://www.usbr.gov/foia/",
    noFear: "https://www.doi.gov/pmb/eeo/no-fear-act",
    oig: "https://www.doioig.gov/",
    performance: "https://www.usbr.gov/budget/",
    privacy: "https://www.usbr.gov/main/privacy.html",
  },
  media: {
    photos: [
      {
        file: "/media/usbr-grand-coulee.jpg",
        small: "/media/usbr-grand-coulee-sm.jpg",
        alt: "Aerial view of Grand Coulee Dam releasing water over its spillway into the Columbia River, with the towns and dry hills of central Washington around it.",
        title: "Grand Coulee Dam, Columbia River, Washington",
        creator: "U.S. Bureau of Reclamation",
        source: "https://commons.wikimedia.org/wiki/File:Grand_Coulee_Dam_aerial.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
